import React from "react";
import CollapseButton from "../CollapseButton";
import MatterDetailsTab from "../MatterDetailsTab";
import DocumentTabLabel from "../DocumentTabLabel";

/**
 * Render functions for different tab types
 */

export const renderDocumentTab = (tab, props) => (
  <DocumentTabLabel
    tab={tab}
    activeTab={props.activeTab}
    renameEditFlag={props.renameEditFlag}
    titleName={props.titleName}
    setTitleName={props.setTitleName}
    updateTitleName={props.updateTitleName}
    renameDocument={props.renameDocument}
    handleBlur={props.handleBlur}
  />
);

export const renderTabContent = (tab, props) => {
  if (tab.id === "0") {
    return <CollapseButton setShowSideBar={props.setShowSideBar} />;
  }
  if (tab.id === "1") {
    return <MatterDetailsTab tab={tab} activeTab={props.activeTab} matterDetails={props.matterDetails} matterDetailsTree={props.matterDetailsTree} />;
  }
  return renderDocumentTab(tab, props.renderDocumentTabProps);
};
